import { Observable } from 'rxjs';
import { RemoteApiService } from 'src/app/core';
import { Injectable } from '@angular/core';


export interface ConfigApiResult{
  id: string;
  key: string;
  description: string;
  valueType: string;
  value: string;
}

@Injectable()
export class ConfigService {

  private lifecycleKey: string = 'sia.audio.lifecycle';

  constructor(private remoteApi: RemoteApiService) { }

  findConfigByKey(key: string):Observable<ConfigApiResult>{
    return this.remoteApi.getConfig<ConfigApiResult>(`/configs`, {key});
  }

  findLifecycle():Observable<ConfigApiResult>{
    return this.remoteApi.getConfig<ConfigApiResult>(`/configs`, {key: this.lifecycleKey});
  }

  updateConfig(key: string, value: string):Observable<ConfigApiResult>{
      const config = {
        key,
        value
      }
      return this.remoteApi.postConfig<ConfigApiResult>('/configs', config);
  }

}
